<div>
  <h3>¡Hola!</h3>
  <p>Inicia Sesión con tu cuenta</p>
  <zafe-google-button-small></zafe-google-button-small>
  <p class="my-3">o</p>
  <zafe-email-password-login-small></zafe-email-password-login-small>
</div>
